import Vue from 'vue'
import _ from 'underscore'

export default {

    namespaced: true,

    state: {

        data: {}

    },

    getters: {

        all: function(state) {

            return state.data

        },

        game: function(state) {

            return state.data.game || {}

        },

        overview: function(state) {

            return state.data.overview || {}

        },

        context: function(state) {

            return state.data.context || {}

        },

        plays: function(state) {

            return state.data.plays || {}

        },

        players: function(state) {

            return state.data.players || {}

        },

        playercount: function(state) {

            return state.data.playercount || {}

        },

        peers: function(state) {

            return state.data.peers || {}

        },

        affinity: function(state) {

            return state.data.affinity || {}

        },

        recommendations: function(state) {

            return state.data.recommendations || {}

        },

        history: function(state) {

            return state.data.history || []

        },

        scores: function(state) {

            return state.data.scores || {}

        },

        calendar: function(state) {

            return state.data.calendar || []

        },

        heatmap: function(state) {

            return state.data.heatmap || {}

        },

        related: function(state) {

            return state.data.related || {}

        },

        tags: function(state) {

            return state.data.tags || []

        },

        ratings: function(state) {

            return state.data.ratings || {}

        },

        worth: function(state) {

            return state.data.worth || {}

        },

        recent: function(state) {

            return state.data.recent || { list: [], total: 0 }

        },

        timeline: function(state) {

            return state.data.timeline || { events: [], total: 0 }

        }

    },

    mutations: {

        reset: function(state) {

            state.data = {}

        },

        set: function(state, data) {

            _.each(data, function(value, key) {

                Vue.set(state.data, key, value)

            })

        }

    },

    actions: {}

}
